var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-portal"},[_c('HeroSection'),_c('SolutionSection'),_c('HonorSection'),_c('ProductSection'),_c('OpenSourceSection'),_c('WritingSection'),_c('StorySection'),_c('ContactSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }